import { MutationTree } from 'vuex';
import { Inventory } from '@/interface/store/inventory';
import { initialState } from '@/store/modules/inventory/index';

export const mutations: MutationTree<Inventory> = {
  SET_INVENTORY(state, payload) {
    state.dataList = payload.data;
    state.totalCount = payload.totalCount;
  },
  SET_MOBILE_INVENTORY(state, payload) {
    state.dataList = state.dataList.concat(payload.data);
    state.totalCount = payload.totalCount;
  },
  SET_INVENTORY_ITEM(state, payload) {
    state.inventoryItem = payload;
  },
  SET_QUERY_PARAMS(state, payload) {
    state.queryParams = payload;
  },
  UPDATE_QUERY_PARAMS(state, payload) {
    state.queryParams = Object.assign(state.queryParams, payload);
  },
  SET_INVENTORY_ATTACHMENTS(state, payload) {
    state.inventoryAttachments = payload.data;
  },
  SET_INVENTORY_HISTORIES(state, payload) {
    state.inventoryHistories = payload.data;
  },
  SET_INVENTORY_FILTER(state, payload) {
    state.inventoryFilter = payload;
  },
  SET_INVENTORY_FILTER_STACK(state, payload) {
    state.inventoryFilterStack = payload;
  },
  RESET_ALL(state) {
    const initialInventoryState = initialState();
    Object.keys(initialInventoryState).forEach((key: any) => {
      (state as any)[key] = (initialInventoryState as any)[key];
    });
  },
};
